import { render, staticRenderFns } from "./toBereviewed.vue?vue&type=template&id=62760144&"
import script from "./toBereviewed.vue?vue&type=script&lang=js&"
export * from "./toBereviewed.vue?vue&type=script&lang=js&"
import style0 from "./toBereviewed.vue?vue&type=style&index=0&id=62760144&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports